(function ($) {
    const tabs = $("#info-tabs-list");
    const bg_color = tabs.data("bg");
    const color = tabs.data("color");
    const active_bg_color = tabs.data("active-bg");
    const active_color = tabs.data("active-color");
    const content_color = tabs.data("content-color");


    tabs.find("li a").css("color", color);
    tabs.find("li").css("background-color", bg_color);
    tabs.find("li.active a").css("color", active_color);
    tabs.find("li.active").css("background-color", active_bg_color);
    tabs.find("li.active").css("background-color", active_bg_color);

    $(".section-information-box .tab-content").css({'background-color' : active_bg_color, 'color' : content_color});

    //mobile slider
    $('.slider-mobile').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        //adaptiveHeight: true,
        //autoplay: true,
        //autoplaySpeed: 4000,
        arrows: true,
        prevArrow: $('.slider-arrow.prev'),
        nextArrow: $('.slider-arrow.next')
    });

    $('#info-tabs-list li a').on("click",function (e) {
        e.preventDefault();
        $(this).tab('show');
        tabs.find("li a").css("color", color);
        tabs.find("li").css("background-color", bg_color);
        $(this).css("color", active_color);
        $(this).closest("li").css("background-color", active_bg_color);
    })
})(jQuery);